<template>
  <v-container fluid class="pt-3">
    <v-layout row wrap class="control">
      <v-flex xs12 md12 class="text-center">
        <div class="pb-3">
          <el-select
            v-model="form.shop_reference"
            filterable
            placeholder="เลือกร้านค้า"
            :size="`small`"
            class="pr-2"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shop_reference"
              :label="item.name"
              :value="item.shop_reference"
            ></el-option>
          </el-select>

          <el-date-picker
            size="small"
            v-model="daterange"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <el-button
            type="primary"
            :disabled="isLoading"
            class="ml-2"
            size="mini"
            @click="viewReport"
          >ค้นหา</el-button>
        </div>
      </v-flex>
    </v-layout>
    <el-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:item.ref_no="{item}">{{ item.ref_no }}</template>
        <template v-slot:item.name="{item}">{{ item.name }}</template>
        <template v-slot:item.quantity="{item}">{{ item.quantity | numFormat('0,0') }}</template>
        <template v-slot:item.food_amount="{item}">{{ item.food_amount | numFormat('0,0.00') }}</template>
        <template
          v-slot:item.delivery_amount="{item}"
        >{{ item.delivery_amount | numFormat('0,0.00') }}</template>
        <template
          v-slot:item.discount_amount="{item}"
        >{{ item.discount_amount | numFormat('0,0.00') }}</template>
        <template
          v-slot:item.grand_total="{item}"
        >{{ item.grand_total | numFormat('0,0.00') }}</template>
        <!--
        <template v-slot:footer v-if="total!=null">
          <tr class>
            <td :colspan="headers"></td>
            <td class="font-weight-bold blue--text">รวมทั้งหมด</td>
            <td
              class="text-left font-weight-bold blue--text"
            >{{total.quantity | numFormat('0,0')}}</td>
            <td
              class="text-right font-weight-bold blue--text"
            >{{total.food_amount | numFormat('0,0')}}</td>
            <td
              class="text-right font-weight-bold blue--text"
            >{{total.delivery_amount | numFormat('0,0')}}</td>
            <td
              class="text-right font-weight-bold blue--text"
            >{{total.discount_amount | numFormat('0,0')}}</td>
          </tr>
        </template>
        -->
      </v-data-table>
    </el-card>
    <div style="position:fixed; bottom:10px; right:10px; z-index:9; width:100%;">
      <v-pagination circle v-model="page" :total-visible="5" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import Service from "../../services";

import moment from "moment";
export default {
  components: {},
  data() {
    return {
      isLoading: true,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      form: {
        shop_reference: "",
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "ref_no",
        },
        { text: "ชื่อร้านค้า", value: "name" },
        { text: "จำนวนบิล", value: "quantity" },
        { text: "การชำระเงิน", align: "right", value: "payment_type" },
        { text: "ค่าสินค้า", align: "right", value: "food_amount" },
        { text: "ค่าจัดส่ง", align: "right", value: "delivery_amount" },
        { text: "ส่วนลด", align: "right", value: "discount_amount" },
        { text: "คงเหลือ", align: "right", value: "grand_total" },
      ],
      cash_amount:0,
      transfer_amount:0,
      creditcard_amount:0,
      shopList: [],
      items: [],
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      total: null,
    };
  },
  created() {
    Service.Shop.gets().then((res) => {
      if (res.success) {
        this.shopList = res.data.map((item) => {
          return {
            shop_reference: item.ref_no,
            name: item.name,
            status: item.status,
          };
        });

        this.shopList = this.shopList.filter(function (item) {
          return item.status == "published";
        });

        this.shopList.unshift({
          shop_reference: "",
          name: "ทั้งหมด",
          status: "published",
        });

        this.isLoading = false;
      }
    });
  },
  methods: {
    viewReport() {
      let data = {
        begin: this.daterange[0],
        end: this.daterange[1],
        shop_reference: this.form.shop_reference,
      };

      Service.Report.shop(data).then((res) => {
        this.items = res.data.map((item) => {
          return {
            ref_no: item.shop.ref_no,
            name: item.shop.shop_name,
            quantity: item.quantity,
            food_amount: item.food_amount,
            delivery_amount: item.delivery_amount,
            discount_amount: item.discount_amount,
            grand_total : parseFloat(item.food_amount)+parseFloat(item.delivery_amount)+parseFloat(item.discount_amount),
            payment_type:item.payment_type
          };
        });

        this.total = {
          quantity: this.items.reduce(
            (acc, item) => acc + parseInt(item.quantity),
            0
          ),
          food_amount: this.items.reduce(
            (acc, item) => acc + parseInt(item.food_amount),
            0
          ),
          delivery_amount: this.items.reduce(
            (acc, item) => acc + parseInt(item.delivery_amount),
            0
          ),
          discount_amount: this.items.reduce(
            (acc, item) => acc + parseInt(item.discount_amount),
            0
          ),
        };
      });
    },
  },
};
</script>